// Simple Discount Badge Display
// This script detects discounted items and displays badges
// Compatible with Vue.js cart systems

(function() {
  'use strict';
  
  // Function to format currency
  function formatCurrency(cents) {
    if (!cents) return '$0.00';
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }
  
  // Function to add discount badges
  function addDiscountBadges() {
    try {
      // Get all cart items
      const cartItems = document.querySelectorAll('.cart__item');
      
      cartItems.forEach((itemEl) => {
        // Skip if already has a badge
        if (itemEl.querySelector('.discount-badge-simple')) {
          return;
        }
        
        // Get prices from the item
        const priceEl = itemEl.querySelector('.csapps-cart-original-total');
        const compareEl = itemEl.querySelector('[class*="price--sale"]');
        
        if (!priceEl) {
          return; // No price element found
        }
        
        let hasDiscount = false;
        let savingsAmount = 0;
        
        // Check if there's a compare price (sale price)
        if (compareEl) {
          const currentText = priceEl.textContent.trim();
          const compareText = compareEl.textContent.trim();
          
          // Extract just the numbers
          const currentPrice = parseFloat(currentText.replace(/[^0-9.]/g, ''));
          const comparePrice = parseFloat(compareText.replace(/[^0-9.]/g, ''));
          
          if (comparePrice > currentPrice && currentPrice > 0) {
            hasDiscount = true;
            savingsAmount = Math.round((comparePrice - currentPrice) * 100);
          } else if (currentPrice === 0) {
            // Item is free
            hasDiscount = true;
            savingsAmount = Math.round(comparePrice * 100);
          }
        }
        
        // Also check if price is 0 (free item)
        const priceText = priceEl.textContent.trim();
        const priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        
        if (priceValue === 0 && !hasDiscount) {
          hasDiscount = true;
          savingsAmount = 0;
        }
        
        // If discount found, add badge
        if (hasDiscount) {
          const badge = document.createElement('div');
          badge.className = 'discount-badge-simple';
          
          let badgeText = '';
          if (priceValue === 0) {
            badgeText = '🎁 FREE ITEM';
          } else if (savingsAmount > 0) {
            badgeText = '🏷️ You Save: ' + formatCurrency(savingsAmount);
          } else {
            badgeText = '🏷️ Discount Applied';
          }
          
          badge.innerHTML = badgeText;
          priceEl.insertAdjacentElement('afterend', badge);
        }
      });
    } catch (e) {
      console.error('Discount Badge Error:', e);
    }
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(addDiscountBadges, 500);
    });
  } else {
    setTimeout(addDiscountBadges, 500);
  }
  
  // Watch for cart updates using MutationObserver
  try {
    const cartContainer = document.querySelector('.cart__tbody') || 
                         document.querySelector('[data-cart]') ||
                         document.querySelector('.minicart');
    
    if (cartContainer) {
      const observer = new MutationObserver(function() {
        // Debounce the updates
        clearTimeout(observer.timeout);
        observer.timeout = setTimeout(addDiscountBadges, 300);
      });
      
      observer.observe(cartContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      console.log('Discount Badge: MutationObserver started');
    }
  } catch (e) {
    console.log('Discount Badge: MutationObserver not available');
  }
  
  // Also watch for Vue updates if Vue cart exists
  try {
    if (window.vueCartApp && window.vueCartApp.$watch) {
      window.vueCartApp.$watch('shoppingCart.items', function() {
        setTimeout(addDiscountBadges, 300);
      }, { deep: false });
      
      console.log('Discount Badge: Vue watcher initialized');
    }
  } catch (e) {
    console.log('Discount Badge: Vue watcher not available');
  }
  
  // Fallback: Re-check every 2 seconds for new items
  setInterval(addDiscountBadges, 2000);
  
  console.log('Discount Badge Script Loaded');
  
})();